import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import classNames from "classnames/bind";
import styles from "./SidebarLayout.module.scss";
// import HeaderLayout from "./HeaderLayout/HeaderLayout";
import { dataMenuClient } from "../../utils/constants/data";
// import Loading from "../../components/Loading/Loading";
// import { useAppSelector } from "../../redux/hooks";
const css = classNames.bind(styles);

function SidebarLayout({ children }: { children: any }): JSX.Element {
  // const postsFetching = useAppSelector((state) => state.post.isFetching);
  // const topicsFetching = useAppSelector((state) => state.topic.isFetching);
  // const isLoading = useAppSelector(
  //   (state) => state.post.isFetching || state.topic.isFetching
  // );
  // const isLoading = useAppSelector((state) => state.post.isFetching);

  return (
    <div className="app">
      <Header />
      <div className={css("wrapper")}>
        <Sidebar dataMenu={dataMenuClient} />
        <div className={css("container")}>
          <div className={css("content")}>{children}</div>
          <Footer />
        </div>
        {/* {postsFetching || topicsFetching ? <Loading /> : <></>} */}
        {/* {isLoading ? <Loading /> : <></>} */}
      </div>
    </div>
  );
}

export default SidebarLayout;
